import { colors, fonts, fontSizes } from 'theme'
import css from 'styled-jsx/css'

export default css`
  .badgeleft {
    position: relative;
  }

  .badgeleft[data-badge]:after {
    content: attr(data-badge);
    position: absolute;
    top: -0.25rem;
    right: -0.25rem;
    font: ${fonts.semiBold};
    font-size: ${fontSizes.tiny};
    background: ${colors.badge};
    color: white;
    width: 0.75rem;
    height: 0.75rem;
    text-align: center;
    line-height: 12px;
    border-radius: 50%;
    padding: 1px;
  }

  .badgeright{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1rem;
    height: 1rem;
    background: ${colors.badge};
    font: ${fonts.semiBold};
    font-size: ${fontSizes.tiny};
    color: white;
    border-radius: 50%;
    margin-left: 0.25rem;
  }

  .notification-menu-container {
    position: relative;
  }

  .notification-menu-label {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .notification-menu-label .icon-notification,
  .notification-menu-label.icon-notification .hideOnLarge {
    margin-left: .75rem;
    margin-right: .75rem;
  }

  .notification-menu-content {
    position: absolute;
    top: 3.5rem;
    left: -8.3rem;
    min-width: 13rem;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid ${colors.border};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    visibility: visible;
    opacity: 1;
    z-index: 3;
    background-color: ${colors.white};
    box-shadow: 0 8px 20px 0 rgba(197, 207, 222, 0.5);
    border-radius: 0.25rem;
    transition: opacity 200ms, visibility 200ms;
  }
  @media screen and (max-width: 992px) {
    .notification-menu-content {
      left: -6rem;
    }
  }

  .notification-menu-header {
    height: 2.5rem;
    min-width: 13rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: ${colors.white};
    font: ${fonts.regular};
    font-size: ${fontSizes.tiny};
    color: ${colors.text};
  }
  @media screen and (max-width: 992px) {
    .notification-menu-header {
      display: none;
    }
  }

  .notification-menu-overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }

  .collapsed {
    visibility: hidden;
    opacity: 0;
    transition: opacity 200ms, visibility 200ms;
  }

  .notification-more {
    height: 2rem;
    min-width: 13rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${colors.white};
  }
  @media screen and (max-width: 992px) {
    .notification-more{
      display: none;
    }
  }

  .notification-more :global(a) {
    font: ${fonts.regular};
    font-size: ${fontSizes.tiny};
    color: ${colors.limeGreen};
  }

  .secondary-menu-item {
    height: 2rem;
    min-width: 13rem;
    font: ${fonts.regular};
    font-size: ${fontSizes.tiny};
    color: ${colors.text};
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;
    cursor: pointer;
    font: ${fonts.semiBold};
    font-size: ${fontSizes.small};
    color: ${colors.text};
  }

  @media screen and (min-width: 992px) {
    .secondary-menu-item {
      display: none;
    }
  }
`
